import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function LightningStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...size !== undefined && { width: size, height: size }}
			{...props}
		>
			<path
				d="M18.0001 2.25C18.2674 2.25 18.5143 2.39279 18.6485 2.62402C18.7825 2.85518 18.784 3.14004 18.6514 3.37207L15.293 9.25H19.0001C19.3034 9.25 19.5773 9.43263 19.6934 9.71289C19.8095 9.99313 19.7448 10.3158 19.5303 10.5303L8.53032 21.5303C8.29199 21.7686 7.92424 21.8183 7.63091 21.6523C7.33763 21.4863 7.19088 21.1453 7.27251 20.8184L9.04009 13.75H5.00005C4.74555 13.75 4.50835 13.6209 4.37017 13.4072C4.232 13.1935 4.21203 12.9245 4.31646 12.6924L8.81646 2.69238L8.86822 2.5957C9.00465 2.38239 9.24189 2.25 9.50005 2.25H18.0001ZM6.15923 12.25H10.0001C10.2308 12.25 10.4487 12.3563 10.5909 12.5381C10.733 12.7201 10.7835 12.9577 10.7276 13.1816L9.38384 18.5547L17.1895 10.75H14.0001C13.7327 10.75 13.4858 10.6072 13.3516 10.376C13.2176 10.1448 13.2161 9.85996 13.3487 9.62793L16.7071 3.75H9.98443L6.15923 12.25Z"
				fill="currentColor"
			/>
		</svg>
	);
}

LightningStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default LightningStrokeIcon;
